'use client';

import { useState, useEffect } from 'react';

import { useModal } from '@/contexts/ModalContext';
import Text from '@/components/common/Text';
import Tooltip from '@/components/common/Tooltip';
import BurnIngicator from '@/components/common/BurnIngicator';
import GoalListModal from '@/components/goals/GoalListModal';
import { GoalModel, getGoalStageReasonString } from '@/types/goals';

interface FootballlogGoalsEditProps {
  propsGoal: GoalModel | undefined;
  onChangeGoal?: (goal: GoalModel | undefined) => void;
  onMoveToGoals?: () => void;
}

/**
 * 目標コンポーネント
 * @param param0
 * @returns
 */
export default function FootballlogGoalsEdit({ propsGoal, onChangeGoal, onMoveToGoals }: FootballlogGoalsEditProps) {
  const { openModal } = useModal();

  /**
   * useState
   */
  const [goal, setGoal] = useState<GoalModel | undefined>(propsGoal);

  const handleSetGoal = (selectedGoal: GoalModel | undefined) => {
    setGoal(selectedGoal);
    onChangeGoal && onChangeGoal(selectedGoal);
  };

  /**
   * Goalsリストモーダル表示
   */
  const handleOpenGoalsDrawer = () => {
    openModal(<GoalListModal propsSelectedGoal={goal} onSelectGoal={handleSetGoal} onMoveToGoals={onMoveToGoals} />);
  };

  useEffect(() => {
    setGoal(propsGoal);
  }, [propsGoal]);

  return (
    <>
      <div
        className="relative w-full bg-cover bg-center rounded-lg bg-gray-50 shadow"
        style={{ backgroundImage: "url('/images/goals.jpg')" }}>
        {goal ? (
          <>
            <div className="flex">
              <div className="grow p-4 whitespace-pre-line break-all">
                <Text className="text-xl font-semibold italic text-green-800">{goal.immediate_goal}</Text>
              </div>
              <button
                type="button"
                onClick={handleOpenGoalsDrawer}
                className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded-full text-white bg-gray-400 bg-opacity-60 hover:bg-gray-400 hover:bg-opacity-100 text-sm dark:hover:bg-gray-600 dark:hover:text-white">
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"
                  />
                </svg>
                <span className="sr-only">open menu</span>
              </button>
            </div>
            <div className="mt-1 p-4">
              <Tooltip content={getGoalStageReasonString(goal?.progress.reason_code) || '-'} position="bottom-right">
                <BurnIngicator stage={goal.progress.stage} />
              </Tooltip>
            </div>
          </>
        ) : (
          <>
            <div className="flex h-24">
              <div className="grow p-4 whitespace-pre-line break-all">
                <Text className="text-base italic text-gray-500">目標・課題が設定されていません</Text>
              </div>
              <button
                type="button"
                onClick={handleOpenGoalsDrawer}
                className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded-full text-white bg-gray-400 bg-opacity-60 hover:bg-gray-400 hover:bg-opacity-100 text-sm dark:hover:bg-gray-600 dark:hover:text-white">
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"
                  />
                </svg>
                <span className="sr-only">open menu</span>
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
